import { createSlice } from '@reduxjs/toolkit'

const searchHeaderSlice = createSlice({
  name: 'searchHeader',
  initialState: {
    activeTab: 'data_ready_status',
    searchText: '',
    blockerFilter: '',
  },
  reducers: {
    setActiveTab: (state, action) => {
      const { payload } = action
      return {
        ...state,
        activeTab: payload.name,
        searchText: payload.searchText,
        blockerFilter: payload.blockerFilter,
      }
    },
  },
})

export const { setActiveTab } = searchHeaderSlice.actions
export default searchHeaderSlice.reducer
